import SpendBonusInvestmentsPath from '/assets/icons/spend-bonus-investments.svg'
import SpendDigitalBankingPath from '/assets/icons/spend-digital-banking.svg'
import SpendInvestPath from 'assets/icons/spend-invest.svg'
import SpendNoFeesPath from 'assets/icons/spend-no-fees.svg'
import SpendTungstenMetalPath from 'assets/icons/spend-tungsten-metal.svg'

export const spendDetails = [
  {
    altText: 'invest',
    text: 'Invest your spare change and easily save for retirement',
    imagePath: SpendInvestPath,
  },
  {
    altText: 'no fees',
    text: 'No minimum-balance fees, overdraft fees, and fee-reimbursed ATMs',
    imagePath: SpendNoFeesPath,
  },
  {
    altText: 'tungsten metal card',
    text: 'A tungsten metal, matte green card with your name engraved',
    imagePath: SpendTungstenMetalPath,
  },
  {
    altText: 'bonus investments when you shop',
    text: 'Bonus investments when you shop and money tips on the go',
    imagePath: SpendBonusInvestmentsPath,
  },
  {
    altText: 'digital banking',
    text: 'Digital banking with mobile check deposit, check sending, and more',
    imagePath: SpendDigitalBankingPath,
  },
]

export const investAccordionContent = [
  {
    header: 'Automated Investing',
    text:
      'Invest your spare change, set Recurring Investments and grow faster from reinvested dividends',
  },
  {
    header: 'Smart Portfolios',
    text: 'Constructed with help from a Nobel Prize winning economist, Dr. Harry Markowitz',
  },
  {
    header: 'Acorns Earn',
    text: '350+ top brands invest in you when you shop',
  },
  {
    header: 'Acorns Protect',
    text:
      'Select insurance partners to help you save when the unexpected happens, and protect what you love',
  },
]

export const laterAccordionContent = [
  {
    header: 'An Easy Way to Save for Retirement',
    text: 'Set up in under 3 minutes and save for later with potential tax advantages',
  },
  {
    header: 'Your IRA',
    text: 'With Traditional, SEP and Roth IRA plans, we’ll recommend the one that’s right for you.',
  },
  {
    header: 'Recurring Contributions',
    text: 'Set an automatic Recurring Contribution',
  },
  {
    header: 'Anytime, Anywhere',
    text: 'Invest extra cash to grow for later — as little as $5',
  },
]
